"use client";

import BFLLink from "@repo/shared-ui/BFLLink";
import { scrollTo } from "@repo/shared-utils/common-utils";
import { selectLoginStatus, useAppSelector } from "@repo/web-store";
import { handleBackToTopDL } from "./BackToTopFunction";

const BackToTop = ({ gotoTopText }: { gotoTopText: string }) => {
  const loginStatus = useAppSelector(selectLoginStatus);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    // Get the text content for analytics
    const cta_text = e.currentTarget.textContent?.trim() || "Go To Top";
    handleBackToTopDL(loginStatus, cta_text);
    scrollTo(0, "smooth");
  };

  return (
    <BFLLink
      className="flex-center-center bg-stealblue-100 w-full cursor-pointer gap-2 p-3 text-center text-xs leading-[17px] md:text-sm"
      onClick={handleClick}
    >
      <i className="icomoon before:content-['\e910']"></i>
      {gotoTopText ?? "Go To Top"}
    </BFLLink>
  );
};

export default BackToTop;
